import { Injectable } from '@angular/core';
import { Experience, SearchWhereResult } from './interfaces/experiences';

export interface ExperiencesPageState {
  // Filters
  selectedLangs: any[];
  selectedServices: any[];
  selectedTypes: string[];
  rangeDates: Date[] | undefined;
  numPax: number | undefined;
  priceRangeValues: number[];
  selectedWhereAdvanced: SearchWhereResult | undefined;
  searchText: string | undefined;
  
  // Map state
  showMap: boolean;
  mapBoundCoords: any;
  
  // Page state
  scrollPosition: number;
  currentPage: number;
  experiecesCards: Experience.Short[];
  
  // Filter UI state
  datesText: string;
  numPersone: string;
  pricePopUpText: string;
  iconCalendar: string;
  iconPerson: string;
  iconPrice: string;
  iconLanguage: string;
  iconServices: string;
}

@Injectable({
  providedIn: 'root'
})
export class ExperiencesStateService {
  private state: ExperiencesPageState | null = null;

  saveState(state: ExperiencesPageState): void {
    this.state = { ...state };
  }

  getState(): ExperiencesPageState | null {
    return this.state;
  }

  clearState(): void {
    this.state = null;
  }

  hasState(): boolean {
    return this.state !== null;
  }
}
